<template>
  <el-dialog
    :title="title"
    :visible="true"
    width="698px"
    :close-on-click-modal="false"
    :before-close="handleClose"
  >
    <el-form
      ref="invoiceBookForm"
      label-position="top"
      :model="invoiceBook"
      :rules="rules"
      v-loading="loading"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            label="Név"
            prop="name"
          >
            <el-input
              v-model="invoiceBook.name"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="Előtag"
            prop="prefix"
          >
            <el-input
              v-model="invoiceBook.prefix"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            label="Deviza"
            prop="currency_id"
          >
            <el-select
              v-model="invoiceBook.currency_id"
              style="width: 100%;"
              filterable
              clearable
            >
              <el-option
                v-for="currency in currencies"
                :key="currency.id"
                :value="currency.id"
                :label="currency.name"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="Főkönyvi szám"
            prop="gla_number_id"
          >
            <el-select
              v-model="invoiceBook.gla_number_id"
              style="width: 100%;"
              filterable
              clearable
            >
              <el-option
                v-for="glaNumber in glaNumbers"
                :key="glaNumber.id"
                :value="glaNumber.id"
                :label="glaNumber.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            label="Sablon"
            prop="invoice_book_template_id"
          >
            <el-select
              v-model="invoiceBook.invoice_book_template_id"
              style="width: 100%;"
              filterable
              clearable
            >
              <el-option
                v-for="invoiceBookTemplate in invoiceBookTemplates"
                :key="invoiceBookTemplate.id"
                :value="invoiceBookTemplate.id"
                :label="invoiceBookTemplate.name"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="Raktár"
            prop="storage_id"
          >
            <el-select
              v-model="invoiceBook.storage_id"
              style="width: 100%;"
              filterable
              clearable
            >
              <el-option
                v-for="storage in storages"
                :key="storage.id"
                :value="storage.id"
                :label="storage.name"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            label="Saját cég"
            prop="own_company_id"
          >
            <el-select
              v-model="invoiceBook.own_company_id"
              style="width: 100%;"
              filterable
              clearable
            >
              <el-option
                v-for="ownCompany in ownCompanies"
                :key="ownCompany.id"
                :value="ownCompany.id"
                :label="ownCompany.name"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="Alapértelmezett példányszám"
            prop="default_copies"
          >
            <el-input
              v-model.number="invoiceBook.default_copies"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" style="display: flex; align-items: center">
        <el-col :span="12">
          <el-form-item
            label="Régió"
            prop="region"
          >
            <el-select
              v-model="invoiceBook.region"
              style="width: 100%;"
              filterable
              clearable
            >
              <el-option
                value="inland"
                label="Belföldi"
              >
                Belföldi
              </el-option>
              <el-option
                value="abroad"
                label="Külföldi"
              >
                Külföldi
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            label="Kp. megjegyzés"
            prop="cash_comment"
          >
            <el-input
              v-model="invoiceBook.cash_comment"
              type="textarea"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="Ut. megjegyzés"
            prop="transfer_comment"
          >
            <el-input
              v-model="invoiceBook.transfer_comment"
              type="textarea"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item
            prop="is_real"
            style="display: flex; align-items: center; margin-bottom: 0"
          >
            <el-checkbox v-model="invoiceBook.is_real">
              Valódi tömb
            </el-checkbox>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            prop="is_product_billable"
          >
            <el-checkbox v-model="invoiceBook.is_product_billable">
              Termék számlázandó
            </el-checkbox>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            prop="is_service_billable"
          >
            <el-checkbox v-model="invoiceBook.is_service_billable">
              Szolgáltatás számlázandó
            </el-checkbox>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="handleClose">
        Mégse
      </el-button>
      <el-button
        type="primary"
        :loading="buttonLoading"
        @click="store"
      >
        {{ buttonText }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
  import streetSuffixes from '../../../config/streetSuffixes';

  export default {
    props: ['type', 'invoiceBookId'],
    data() {
      return {
        loading: false,
        addressLoading: false,
        buttonLoading: false,
        invoiceBookTemplates: [],
        streetSuffixes,
        invoiceBook: {
          is_product_billable: true,
          is_service_billable: false,
          is_real: true,
        },
        filterMethod(query, item) {
          return item.label.toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .indexOf(query.toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')) > -1;
        },
        rules: {
          name: [
            {
              required: true,
              message: 'Mező megadása kötelező',
              trigger: 'change'
            }
          ],
          default_copies: [
            {
              required: true,
              message: 'Mező megadása kötelező',
              trigger: 'change'
            },
            { type: 'number', message: 'Mező csak számot tartalmazhat'}
          ],
          currency_id: [
            {
              required: true,
              message: 'Mező megadása kötelező',
              trigger: 'change'
            }
          ],
          gla_number_id: [
            {
              required: true,
              message: 'Mező megadása kötelező',
              trigger: 'change'
            }
          ],
          invoice_book_template_id: [
            {
              required: true,
              message: 'Mező megadása kötelező',
              trigger: 'change'
            }
          ],
          own_company_id: [
            {
              required: true,
              message: 'Mező megadása kötelező',
              trigger: 'change'
            }
          ],
          prefix: [
            {
              required: true,
              message: 'Mező megadása kötelező',
              trigger: 'change'
            }
          ],
          region: [
            {
              required: true,
              message: 'Mező megadása kötelező',
              trigger: 'change'
            }
          ],
          storage_id: [
            {
              required: true,
              message: 'Mező megadása kötelező',
              trigger: 'change'
            }
          ]
        },
      };
    },
    computed: {
      storages() {
        return this.$store.getters['storage/storages'];
      },
      ownCompanies() {
        return this.$store.getters['ownCompany/ownCompanies'];
      },
      currencies() {
        return this.$store.getters['currency/currencies'];
      },
      glaNumbers() {
        return this.$store.getters['glaNumber/glaNumbers'];
      },
      title() {
        if (this.type === 'add') {
          return 'Új számlatömb';
        } else if (this.type === 'update') {
          return 'Számlatömb módosítása';
        } else {
          return '';
        }
      },
      buttonText() {
        if (this.type === 'add') {
          return 'Hozzáadása';
        } else if (this.type === 'update') {
          return 'Módosítás';
        } else {
          return '';
        }
      },
    },
    async mounted() {
      this.loading = true;
      await Promise.all([
        this.$store.dispatch('glaNumber/fetchAll'),
        this.$store.dispatch('currency/fetchAll'),
        this.$store.dispatch('storage/fetchAll'),
        this.$store.dispatch('ownCompany/fetchAll'),
        this.$store.dispatch('ownCompany/fetchAll'),
        this.invoiceBookTemplates = axios.get('api/invoice-book-templates'),
      ]);
      this.invoiceBookTemplates.then(values => this.invoiceBookTemplates = values);
      if (this.invoiceBookId) {
        this.invoiceBook = await this.$store.dispatch('invoiceBook/fetch', this.invoiceBookId);
      }
      this.loading = false;
    },
    methods: {
      handleClose() {
        this.$confirm('Biztosan elveted a módosításokat?', {
          confirmButtonText: 'Igen',
          type: 'warning',
        })
        .then(() => {
          this.$router.replace('/sales/invoice-books');
        })
        .catch(() => {
        });
      },

      async store() {
        this.$refs['invoiceBookForm'].validate(async valid => {
          if (valid) {
            this.buttonLoading = true;
            try {
              if (this.type === 'add') {
                await this.$store.dispatch('invoiceBook/create', this.invoiceBook);
              } else if (this.type === 'update') {
                await this.$store.dispatch('invoiceBook/update', this.invoiceBook);
              }
              this.$store.dispatch('invoiceBook/fetchAll');
              this.buttonLoading = false;
              this.$router.replace('/sales/invoice-books');
            } catch (e) {
            }
            this.buttonLoading = false;
          }
        });
      }
    },
  };
</script>
